import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynFormParserService } from './dyn-form-parser.service';
import { UntypedFormBuilder } from '@angular/forms';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [DynFormParserService, UntypedFormBuilder]
})
export class DynFormParserModule {}
